import script from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawTotals.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawTotals.vue?vue&type=style&index=0&id=a33998d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a33998d4"]])

export default __exports__